// extracted by mini-css-extract-plugin
module.exports = {"imageListContent":"imageListContent_1dp58","imageDialogContent":"imageDialogContent_2zZbi","imgSelectionRow":"imgSelectionRow_3naBA","detailsCol":"detailsCol_18E4s"};